import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import POFilter from './pomasters-filter';
import POTable from './pomasters-table';
import POTile from './pomasters-tile';
import POSearch from './pomasters-search';
import { selectPOFilterVisible, selectTileView } from './store/selectors';
import { fetchPOsWithFilters, actions } from './store/slice';

const { resetFilters } = actions;

const POContent = () => {
  const dispatch = useDispatch();
  const isFilterVisible = useSelector(selectPOFilterVisible);
  const showTileView = useSelector(selectTileView);

  useEffect(() => {
    dispatch(fetchPOsWithFilters());
    return () => {
      dispatch(resetFilters());
    };
  }, [dispatch]);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <POSearch />
        </div>
        {isFilterVisible && <POFilter />}

        {!showTileView ? <POTable /> : <POTile />}
      </div>
    </div>
  );
};

export default POContent;
